import React from "react";
import { ControlIcon } from "src/scenes/Chat/components/ChatCallPanel.styled";

const MediaIcon = ({ type, disabled = false }) => (
    <ControlIcon $disabled={disabled}>
        {type === "video" ? (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                    d="M4.75 7.25C4.75 6.56 5.31 6 6 6h7.25c.69 0 1.25.56 1.25 1.25v9.5c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25v-9.5Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                />
                <path
                    d="m14.5 10 4.75-2.75v9.5L14.5 14"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ) : type === "background" ? (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4.5 6.5h15v11h-15z" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="m7 15 3.2-3.2 2.3 2.3 1.8-1.8L18 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <circle cx="16.3" cy="9.2" r="1.2" fill="currentColor" />
            </svg>
        ) : type === "screen" ? (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4.5 5.75h15v10.5h-15z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                <path d="M9 19.25h6M12 16.25v3M12 8.75v4.5M9.9 10.85 12 8.75l2.1 2.1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ) : type === "settings" ? (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 15.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z" fill="none" stroke="currentColor" strokeWidth="2" />
                <path d="M18.25 12a6.4 6.4 0 0 0-.08-1l2-1.55-2-3.45-2.38.95a6.52 6.52 0 0 0-1.73-1L13.7 3.4h-4l-.36 2.55a6.52 6.52 0 0 0-1.73 1L5.25 6l-2 3.45L5.25 11a6.41 6.41 0 0 0 0 2l-2 1.55 2 3.45 2.38-.95a6.52 6.52 0 0 0 1.73 1l.36 2.55h4l.36-2.55a6.52 6.52 0 0 0 1.73-1l2.38.95 2-3.45-2-1.55c.05-.33.08-.66.08-1Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
        ) : (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                    d="M12 14.75a3.25 3.25 0 0 0 3.25-3.25v-4a3.25 3.25 0 0 0-6.5 0v4A3.25 3.25 0 0 0 12 14.75Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                />
                <path d="M5.75 11.25a6.25 6.25 0 0 0 12.5 0M12 17.5v3" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
        )}
    </ControlIcon>
);

export default MediaIcon;
